export const GET_ANNOUNCEMENT_LIST = 'GET_ANNOUNCEMENT_LIST'
export const GET_ANNOUNCEMENT_DETAIL_BY_ID = 'GET_ANNOUNCEMENT_DETAIL_BY_ID'
export const GET_TEMPLATE_FILTERS = 'GET_TEMPLATE_FILTERS'
export const GET_TEMPLATE_LIST = 'GET_TEMPLATE_LIST'
export const SET_TEMPLATE_SEARCH_CRITERIA = 'SET_TEMPLATE_SEARCH_CRITERIA'
export const GET_TEMPLATE_DETAILS_BY_ID = 'GET_TEMPLATE_DETAILS_BY_ID'
export const SET_ACTIVE_TEMPLATES = 'SET_ACTIVE_TEMPLATES'
